import AddLicenseForm from './AddLicenseForm';

export default AddLicenseForm;
